import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';

export default function useVaultDataEvent() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { vaultDataAvailable, vaultDataMapped, vehicleId } =
    useGetVehicleDetails();

  useEffectOnce(() => {
    const eventData = {
      vaultDataAvailable: vaultDataAvailable ?? false,
      vaultDataMapped: vaultDataMapped ?? false,
      vehicleId
    };

    trackEvent('Vault Data', eventData);
    datadogRum.addAction('Vault Data', eventData);
  }, [trackEvent, vaultDataAvailable, vaultDataMapped, vehicleId]);
}
